import React from "react";
//outsource
import { Input, Form } from "antd";

//components

const ServiceSpecialPrice = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="price"
      label="Special Price"
      rules={[
        {
          required: true,
          message: "Please insert the Special Price",
        },
        {
          pattern: /^[0-9]+$/,
          message: "Number only",
        },
      ]}
    >
      <Input type="number" placeholder="Special Price" />
    </Form.Item>
  );
};

export default ServiceSpecialPrice;
